import React from 'react';

import LegalLayout from './LegalLayout';
import legalConfig from './legalConfig';

const DataDeletion = () => {
    return (
        <LegalLayout
            eyebrow="Control sobre tus datos"
            title="Eliminación de datos personales"
            description="Solicita la eliminación de información compartida con Secundaria Babeque mediante el sitio web o WhatsApp."
        >
            <section className="legal-section">
                <p className="legal-section__number">01</p>
                <div>
                    <h2>Cómo presentar una solicitud</h2>
                    <p>
                        La persona titular, su representante autorizado o el padre, madre o tutor de un menor puede
                        solicitar la eliminación de información tratada por <strong>{legalConfig.legalName}</strong>.
                    </p>
                    <ol className="legal-steps">
                        <li>
                            <strong>Envía un correo.</strong>
                            <span>Escribe a {legalConfig.privacyEmail} con el asunto “Solicitud de eliminación de datos”.</span>
                        </li>
                        <li>
                            <strong>Identifica la información.</strong>
                            <span>Indica tu nombre, el número de WhatsApp o correo utilizado y qué información deseas eliminar.</span>
                        </li>
                        <li>
                            <strong>Espera la verificación.</strong>
                            <span>Podremos pedir información mínima adicional para confirmar tu identidad y proteger tus datos.</span>
                        </li>
                    </ol>
                </div>
            </section>

            <section className="legal-section">
                <p className="legal-section__number">02</p>
                <div>
                    <h2>Seguridad de la solicitud</h2>
                    <div className="legal-security-callout">
                        <strong>No envíes contraseñas ni códigos.</strong>
                        <p>
                            Nunca solicitaremos contraseñas de WhatsApp, correo ni códigos de autenticación. Si fuera
                            necesario comprobar la identidad, pediremos únicamente la información indispensable.
                        </p>
                    </div>
                </div>
            </section>

            <section className="legal-section">
                <p className="legal-section__number">03</p>
                <div>
                    <h2>Recepción y respuesta</h2>
                    <p>
                        Confirmaremos la recepción dentro de {legalConfig.deletionAcknowledgement} y responderemos o
                        informaremos el estado de la solicitud dentro de {legalConfig.deletionCompletion}. Si el caso
                        requiere más tiempo, explicaremos la razón y el nuevo plazo estimado.
                    </p>
                </div>
            </section>

            <section className="legal-section">
                <p className="legal-section__number">04</p>
                <div>
                    <h2>Qué ocurre con los datos</h2>
                    <p>
                        Una vez validada la solicitud, eliminaremos o anonimizaremos los datos de los sistemas bajo
                        control de la institución y solicitaremos la eliminación a nuestros proveedores cuando
                        corresponda. También detendremos las comunicaciones por WhatsApp que dependan del consentimiento
                        retirado.
                    </p>
                    <p>
                        Podremos conservar de forma bloqueada únicamente la información exigida por ley o necesaria
                        para seguridad, prevención de fraude o defensa de reclamaciones. Informaremos al solicitante
                        cuando exista una razón que impida la eliminación total o inmediata.
                    </p>
                </div>
            </section>

            <section className="legal-section">
                <p className="legal-section__number">05</p>
                <div>
                    <h2>Contacto</h2>
                    <p>
                        Responsable: {legalConfig.privacyArea}.<br />
                        Correo: {legalConfig.privacyEmail}.<br />
                        Dirección: {legalConfig.address}.<br />
                        Teléfono: {legalConfig.phone}.
                    </p>
                    <p>
                        Este procedimiento cubre los datos recibidos mediante {legalConfig.metaService} y los canales
                        digitales bajo control de la institución.
                    </p>
                </div>
            </section>

            <section className="legal-sources" aria-labelledby="deletion-sources-title">
                <h2 id="deletion-sources-title">Referencias</h2>
                <ul>
                    <li><a href="https://dgii.gov.do/transparencia/marcoLegal/Documents/Leyes/172-13.pdf" target="_blank" rel="noreferrer">Ley 172-13 sobre Protección de Datos Personales</a></li>
                    <li><a href="https://whatsappbusiness.com/policy/" target="_blank" rel="noreferrer">Política de mensajería de WhatsApp Business</a></li>
                </ul>
            </section>
        </LegalLayout>
    );
};

export default DataDeletion;
